import React from "react";
import styles from "./expensereport.module.css";
import basestyles from "../../../shared/styles/basestyles.module.css";
import Header from "../../../shared/components/Header/Header";
import Backicon from "../../../shared/components/Backicon/Backicon";

class ExpenseReport extends React.Component {
  state = {
    expenseReportData: "",
  };

  componentDidMount() {
    console.log("expense report");
    this.setState({
      expenseReportData: JSON.parse(
        localStorage.getItem("expense_report_info")
      ),
    });
  }

  render() {
    return (
      <>
        <div className={styles.backgroundpic}>
          <div className={basestyles.inputWidth}>
            <Header
              name="Expense Report"
              style={{
                margin: "10px auto",
              }}
            />
            <Backicon
              onClick={() => this.props.history.goBack()}
              style={{
                background:
                  "linear-gradient(60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
                color: "white",
              }}
            />
            {this.state.expenseReportData === null ? (
              <div className={styles.waitinginfo}>
                <h1>Record Has Not Been Updated.....</h1>
              </div>
            ) : (
              <div className={styles.table}>
                <table>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Phone</th>
                      <th>Diagnose</th>
                      <th>Treatment Cost</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{this.state.expenseReportData.Name}</td>
                      <td>{this.state.expenseReportData.Phone}</td>
                      <td>{this.state.expenseReportData.Diagnose}</td>
                      <td>{this.state.expenseReportData.Treatmentcost}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default ExpenseReport;
